// src/components/PriceModal.tsx
import React from 'react'
import './PriceModal.css'

interface PriceModalProps {
  isOpen: boolean
  value: string
  onChange: (v: string) => void
  onCancel: () => void
  onSubmit: (v: string) => void
}

const PriceModal: React.FC<PriceModalProps> = ({
  isOpen,
  value,
  onChange,
  onCancel,
  onSubmit
}) => {
  if (!isOpen) return null

  return (
    <div className="pm-overlay">
      <div className="pm-container">
        <div className="pm-header">
          <h2 className="pm-title">Building Price</h2>
        </div>

        <div className="pm-body">
          <p className="pm-desc">
            Please enter the price you want to pay for this building
          </p>
          <input
            type="number"
            className="pm-input"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder="e.g. 250000"
          />
        </div>

        <div className="pm-footer">
          <button className="pm-btn pm-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="pm-btn pm-btn--submit"
            onClick={() => onSubmit(value)}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

export default PriceModal
